import React from 'react';
import { motion } from 'framer-motion';

interface SoundButtonProps {
  isMuted: boolean;
  onToggle: () => void;
}

const SoundButton: React.FC<SoundButtonProps> = ({ isMuted, onToggle }) => {
  return (
    <motion.button
      whileTap={{ scale: 0.9 }}
      onClick={onToggle}
      className="fixed top-4 right-4 z-50 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-2xl hidden"
      aria-label={isMuted ? 'Unmute' : 'Mute'}
    >
      {isMuted ? '🔇' : '🔊'}
    </motion.button>
  );
};

export default SoundButton;
